var React = require('react');

function AddCourseIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"64","height":"64","key":0}),React.createElement("path",{"fill":"#5B718D","d":"M54,15 L59,15 L59,18 L54,18 L54,23 L51,23 L51,18 L46,18 L46,15 L51,15 L51,10 L54,10 L54,15 Z M22,20 L42,20 C43.1045695,20 44,20.8954305 44,22 L44,46 C44,47.1045695 43.1045695,48 42,48 L22,48 C20.8954305,48 20,47.1045695 20,46 L20,22 C20,20.8954305 20.8954305,20 22,20 Z M32,38 L36.702282,40.472136 L35.8042261,35.236068 L39.6084521,31.527864 L34.351141,30.763932 L32,26 L29.648859,30.763932 L24.3915479,31.527864 L28.1957739,35.236068 L27.297718,40.472136 L32,38 Z","key":1})]));
}

AddCourseIcon.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = AddCourseIcon;

AddCourseIcon.default = AddCourseIcon;
